/**
 * v-drag
 * @desc 拖动元素
 * @example
 * ```vue
 * <div v-doubleClickToMaxWin="resetDrag" />
 * <div v-draggable /> 默认为true
 * ```
 */
import { DirectiveBinding } from 'vue/types/options.d';
let initLeft = 0;
let initTop = 0;
export default {
  update(el: HTMLElement, binding: DirectiveBinding, vnode: Vue.VNode): void {
    const oDiv = el; // 获取当前元素
    if (binding.value.resetDrag) {
      initLeft = 0;
      initTop = 0;
    }
    if (!binding.value.canDrag) {
      oDiv.onmousedown = null;
      return;
    }
    oDiv.onmousedown = (e: MouseEvent) => {
      e.preventDefault();
      const { offsetLeft, offsetTop } = oDiv;
      // 算出鼠标相对元素的位置
      const disX = e.clientX - offsetLeft;
      const disY = e.clientY - offsetTop;
      if (!initLeft) {
        initLeft = offsetLeft;
      }
      if (!initTop) {
        initTop = offsetTop;
      }
      document.onmousemove = e => {
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        const left = e.clientX - disX - initLeft;
        const top = e.clientY - disY - initTop;

        // 移动当前元素
        oDiv.style.left = `${left}px`;
        oDiv.style.top = `${top}px`;
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  },
};
